export function HamNav() {
  $(".c-ham__openbtn, .c-ham__area a").click(function (event) {
    // aタグのクリックイベントを無視しないようにする
    // if ($(event.target).is('a')) {
    //   event.preventDefault(); // aタグのデフォルトの動作を防ぐ（必要に応じて）
    // }
    $(".c-ham__openbtn").toggleClass('active');
    $(".c-ham__area").toggleClass('active'); // ここでc-ham__areaにもactiveクラスを追加/削除
  });
}